import React from "react";
import "./modal.css";

const Modal = ({ open, onClose, title, children, className = "" }) => {
  if (!open) return null;

   return (
    <div className="modal-overlay">
      <div className={`modal-box ${className}`}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
